var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-segment"},[_c('image-display',{attrs:{"image":_vm.hasImage ? _vm.segmentData.content : _vm.defaultImage,"controls":_vm.segmentData.controls}}),_vm._v(" "),(_vm.segmentData.caption)?_c('p',{staticClass:"image-segment__caption"},[_vm._v(_vm._s(_vm.segmentData.extra))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }